import PropTypes from 'prop-types';

const SharedPortalGroups = {
  id: PropTypes.string,
  name: PropTypes.string,
  location: PropTypes.string,
  custom_logo_url: PropTypes.string,
  custom_background_url: PropTypes.string,
  demo: PropTypes.bool,
  ethnicity_options: PropTypes.string,
  gender_options: PropTypes.string,
  last_edited_by: PropTypes.string,
  created_at: PropTypes.string,
  updated_at: PropTypes.string
};

export default SharedPortalGroups;
